import { Grid } from "@mantine/core";
import StackedBarChart from "./stackedBarChart";

const AssetCost = ({ isAssetChecked, resultSimulationData, isAssetTable, enabledAssets }) => {
  return (
    <Grid gutter="md" className="mt-2 mb-2" justify="space-between">
      <Grid.Col span={3} style={{ minWidth: "100%", height: "100%" }}>
        <StackedBarChart
          stackedData={resultSimulationData?.assetsInfo}
          isAssetChecked={isAssetChecked}
          isAssetTable={isAssetTable}
          enabledAssets={enabledAssets}
        />
      </Grid.Col>
    </Grid>
  );
};

export default AssetCost;
